import { DataTable } from 'simple-datatables'
import 'simple-datatables/dist/style.css'

import * as Tablesaw from 'tablesaw/dist/stackonly/tablesaw.stackonly.js'
import 'tablesaw/dist/stackonly/tablesaw.stackonly.css'

Drupal.behaviors.AutryParagraphTable = {
  attach: (context, settings) => {
    const elements = once(
      'AutryParagraphTable',
      '.paragraph-type--table.is-datatable .tablefield'
    )
    elements.forEach(el => {
      // datatable does NOT get tablesaw treatment
      el.classList.remove('tablesaw')
      el.classList.remove('tablesaw-stack')
      el.removeAttribute('data-tablesaw-mode')

      const dataTable = new DataTable(el, {
        perPageSelect: [5, 10, 25, ['All', -1]]
      })
    })

    // init tablesaw on any others
    Tablesaw.init()
  }
}
